/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1SerievideoVideoidLangs202,
  PostApiV1SerievideoVideoidLangs400,
  PostApiV1SerievideoVideoidLangs401,
  PostApiV1SerievideoVideoidLangs404,
  PostApiV1SerievideoVideoidLangs500,
  PostApiV1SerievideoVideoidLangsMutationRequest,
  PostApiV1SerievideoVideoidLangsMutationResponse,
  PostApiV1SerievideoVideoidLangsPathParams,
  PostApiV1SerievideoVideoidLangsQueryParams,
} from "../../types/serieVideoIdiomasController/PostApiV1SerievideoVideoidLangs.ts";
import { createSerieVideoLangRequestViewModelSchema } from "../createSerieVideoLangRequestViewModelSchema.ts";
import { serieVideoLangViewModelSchema } from "../serieVideoLangViewModelSchema.ts";

export const postApiV1SerievideoVideoidLangsPathParamsSchema = z.object({
  videoId: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1SerievideoVideoidLangsPathParams>;

export const postApiV1SerievideoVideoidLangsQueryParamsSchema = z
  .object({
    serieId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<PostApiV1SerievideoVideoidLangsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1SerievideoVideoidLangs202Schema = z.lazy(
  () => serieVideoLangViewModelSchema,
) as unknown as ToZod<PostApiV1SerievideoVideoidLangs202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1SerievideoVideoidLangs400Schema =
  z.any() as unknown as ToZod<PostApiV1SerievideoVideoidLangs400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1SerievideoVideoidLangs401Schema =
  z.any() as unknown as ToZod<PostApiV1SerievideoVideoidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1SerievideoVideoidLangs404Schema =
  z.any() as unknown as ToZod<PostApiV1SerievideoVideoidLangs404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1SerievideoVideoidLangs500Schema =
  z.any() as unknown as ToZod<PostApiV1SerievideoVideoidLangs500>;

export const postApiV1SerievideoVideoidLangsMutationRequestSchema = z.lazy(
  () => createSerieVideoLangRequestViewModelSchema,
) as unknown as ToZod<PostApiV1SerievideoVideoidLangsMutationRequest>;

export const postApiV1SerievideoVideoidLangsMutationResponseSchema = z.lazy(
  () => postApiV1SerievideoVideoidLangs202Schema,
) as unknown as ToZod<PostApiV1SerievideoVideoidLangsMutationResponse>;
